export { default as Img200 } from './processed/200/Lost-Treasures-of-the-Maya.jpg';
export { default as Img400 } from './processed/400/Lost-Treasures-of-the-Maya.jpg';
export { default as Imgthumb } from './processed/thumb/Lost-Treasures-of-the-Maya.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Lost-Treasures-of-the-Maya.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Lost-Treasures-of-the-Maya.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      179,
      118,
      82
    ],
    "_population": 335,
    "_hsl": [
      0.06185567010309279,
      0.3895582329317268,
      0.5117647058823529
    ]
  },
  "LightVibrant": {
    "_rgb": [
      199,
      134,
      106
    ],
    "_population": 285,
    "_hsl": [
      0.05017921146953405,
      0.4536585365853658,
      0.5980392156862745
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      125,
      40,
      26
    ],
    "_population": 6,
    "_hsl": [
      0.023569023569023573,
      0.6556291390728476,
      0.296078431372549
    ]
  },
  "Muted": {
    "_rgb": [
      147,
      134,
      95
    ],
    "_population": 296,
    "_hsl": [
      0.12500000000000003,
      0.2148760330578512,
      0.4745098039215686
    ]
  },
  "LightMuted": {
    "_rgb": [
      215,
      212,
      207
    ],
    "_population": 2864,
    "_hsl": [
      0.1041666666666669,
      0.09090909090909094,
      0.8274509803921568
    ]
  },
  "DarkMuted": {
    "_rgb": [
      83,
      72,
      50
    ],
    "_population": 2613,
    "_hsl": [
      0.1111111111111111,
      0.2481203007518797,
      0.2607843137254902
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Lost-Treasures-of-the-Maya.js